import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home'
import Timeline from './Components/Timeline/Timeline'
import FAQs from './Components/FAQs/faqs'
import Footer from './Components/Footer/Footer'

function App() {
  return (
    <div>

    <Navbar/>  
    <Home/>
    <Timeline/>
    <FAQs/>
    <Footer/>

    </div>
  )
}

export default App